import { Paper, PaperOwnProps } from "@mui/material";
import { ReactNode } from "react";
import { PagePaperPreambleContainer } from "pages/Layouts/components/PagePaperPreamble";

interface AutoPagePaperLayoutProps {
  children: ReactNode;
  paperProps?: PaperOwnProps;
}

export const AutoPagePaperLayout = ({ children, paperProps }: AutoPagePaperLayoutProps) => {
  const { sx, ...restPaperProps } = paperProps || {};
  return (
    <>
      <PagePaperPreambleContainer />
      <Paper
        variant="outlined"
        {...restPaperProps}
        sx={{
          marginTop: 1,
          "& > .MuiDataGrid-root": {
            border: "none",
          },
          ...sx,
        }}
      >
        {children}
      </Paper>
    </>
  );
};
